export class Country {
  Id: string;
  Name: string;
}
